import { useMqtt } from "./useMqtt";
import { API_EVENTS } from "./mqtt.types";

const mqtt = useMqtt();

mqtt.on(API_EVENTS.EVENT_TEXT_MESSAGE, (mqttPackage) => {
  const message = mqttPackage.eventParams.message;
  //   console.log("[app] mqtt got message:", mqttPackage);
});
